export default __webpack_public_path__ + "static/media/luna.deebea9d.jpeg";